import { Injectable } from '@angular/core';
import { HttpService } from 'projects/apex/src/app/services/http/http.service';
import { Text } from '../../models/text';

@Injectable()
export class TextService extends HttpService<Text> {
  route = 'text';
}
